import { getPropertyEditorStrategy } from '../../helpers/propertyEditorStrategies'
import type { ComponentDefinition, PropertyDefinition } from '../../store/componentRegistry'

interface DynamicPropertyEditorProps {
	propertyName: string
	propertyValue: Record<string, unknown>
	componentDefinition: ComponentDefinition
	onChange: (propertyName: string, value: unknown) => void
}

export function DynamicPropertyEditor({
	propertyName,
	propertyValue,
	componentDefinition,
	onChange,
}: DynamicPropertyEditorProps) {
	const handlePropertyChange = (
		propName: string,
		value: string | number | boolean | null | undefined,
		mutuallyExclusive?: string,
	) => {
		const patch: Record<string, unknown> = { [propName]: value }
		if (mutuallyExclusive && value) {
			patch[mutuallyExclusive] = false
		}
		onChange(propertyName, { ...propertyValue, ...patch })
	}

	return (
		<div className='space-y-3'>
			{componentDefinition.propertyDefinitions?.map((propDef: PropertyDefinition, index: number) => {
				const strategy = getPropertyEditorStrategy(propDef.type)

				const enhancedOptions =
					propDef.type === 'ratingConfig' || propDef.type === 'ratingComponentSelector'
						? propDef.options
							? [...propDef.options, { value: 'context', label: 'context', context: propertyValue }]
							: [{ value: 'context', label: 'context', context: propertyValue }]
						: propDef.options

				const isDisabled =
					propDef.type === 'boolean' && propDef.mutuallyExclusive
						? Boolean(propertyValue[propDef.mutuallyExclusive])
						: false

				return (
					<div key={`${propDef.name}-${index}`} className={isDisabled ? 'opacity-40 pointer-events-none' : undefined}>
						{strategy.getEditorComponent({
							name: propDef.name,
							label: propDef.label,
							value: propertyValue[propDef.name] as string | number | boolean | null,
							onChange: (value) =>
								handlePropertyChange(
									propDef.name,
									value as string | number | boolean | null | undefined,
									propDef.mutuallyExclusive,
								),
							options: enhancedOptions,
							referenceContext: propDef.editorReferenceId ? propertyValue[propDef.editorReferenceId] : undefined,
						})}
					</div>
				)
			})}
		</div>
	)
}
